var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 7a.75.75 0 00-1.5 0v4.25H7a.75.75 0 000 1.5h4.25V17a.75.75 0 001.5 0v-4.25H17a.75.75 0 000-1.5h-4.25V7z",
    fill: "#000"
  })));
}

export default SvgPlus;